export default "__VITE_ASSET__ChdEjBXM__"